
module.exports = {
    RANKEvent_UPDATE_RANK_ITEM: "RANKEvent_UPDATE_RANK_ITEM",

    RankEvent_Get_Time_event: "RankEvent_Get_Time_event",

    //请求排行榜数据
    RankEvent_Get_Rank_data: "RankEvent_Get_Rank_data",

    RankEvent_Get_Skyladder_Partner_data: "RankEvent_Get_Skyladder_Partner_data",

    RankEvent_Get_First_data: "RankEvent_Get_First_data"
}